import React from 'react'
import { Sheet, HeadingText, BodyText, Button } from '@paypalcorp/pp-react'
import { useApplicationContext } from '../../../context/ApplicationContext'
import { getUpgradeBusinessAccountURL } from '../../../utils/app-utils'
import { getUserType } from '../../../utils/user-utils'

function UpgradeAccountAlert({ isUpgradeAlert, closeModal }) {
  const { user } = useApplicationContext()
  const accountType = getUserType(user)
  return (
    <Sheet onClose={closeModal} isOpen={isUpgradeAlert} showLogo={true}>
      <div className="upgrade-card-center-content">
        <div className="upgrade-card-wrapper">
          <img
            src="https://www.paypalobjects.com/paypal-ui/pictograms/blue/svg/transaction-volume-blue.svg"
            alt="transaction-volume-blue"
            style={{ width: '100px' }}
          />
          <HeadingText
            size="sm"
            style={{ marginTop: '10px', textAlign: 'center' }}
            id="upgrade-account-title"
          >
            Upgrade your account
          </HeadingText>
          <BodyText
            style={{ marginTop: '20px', textAlign: 'center' }}
            id="upgrade-account-description"
          >
            Upgrade your account to Paypal for Business account to accept
            invites and to switch to live mode
          </BodyText>
          <Button
            as="a"
            href={getUpgradeBusinessAccountURL({ accountType })}
            role="button"
            target="_blank"
            style={{ marginTop: '50px', marginBottom: '12px' }}
            data-dxa="upgrade_account,redirect,upgrade_account_redirect"
            data-testid="upgradeAccount"
          >
            Upgrade now
          </Button>
        </div>
      </div>
    </Sheet>
  )
}

export default UpgradeAccountAlert
